import { fetcher } from "helpers/fetcher";

import { TGetUsersByPipelineReq, TGetUsersByPipelineRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getUsersByPipeline = async (payload?: TGetUsersByPipelineReq) => {
  return await fetcher<TGetUsersByPipelineRes, TGetUsersByPipelineReq["data"]>(
    ENDPOINT.USER.GET_USERS_BY_PIPELINE,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_USERS_BY_PIPELINE.version,
        [API_HEADER.BU_ID]: payload?.buId,
      },
      data: payload?.data,
      urlData: { pipelineSlug: payload?.path?.pipelineSlug },
    }
  );
};

export const queryGetUsersByPipeline = async (
  payload?: TGetUsersByPipelineReq
) => {
  return (await getUsersByPipeline(payload)).data;
};

queryGetUsersByPipeline._key = (payload?: TGetUsersByPipelineReq) => [
  ENDPOINT.USER.GET_USERS_BY_PIPELINE.url,
  payload,
];
